import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

/**
 * Creates a route wrapper that extracts URL params and passes them
 * as `match.params`, `navigate`, and `location` to the wrapped component.
 *
 * @example
 * const EdgeDeviceDetailsWrapper = createRouteWrapper(EdgeDeviceDetailsPage, ['actionType', 'deviceId', 'tab']);
 */
export function createRouteWrapper(Component, paramKeys) {
  function RouteWrapper() {
    const routeParams = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const matchParams = paramKeys.reduce((acc, key) => {
      acc[key] = routeParams[key];
      return acc;
    }, {});

    return <Component navigate={navigate} location={location} match={{ params: matchParams }} />;
  }

  RouteWrapper.displayName = `RouteWrapper(${Component.displayName || Component.name || 'Component'})`;

  return RouteWrapper;
}

